import { CheckCircle, ShieldCheck, Smartphone, Wifi } from "lucide-react";
import { Button } from "../../components/ui/button";
import { abrirConexaoOficial } from "./abrirConexao";

const VANTAGENS = [
  { icon: ShieldCheck, text: "Conexão oficial da Meta, sem QR Code e sem aparelho pareado" },
  { icon: Smartphone, text: "O app do WhatsApp Business continua no celular — quem atende pelo app pausa a CLEO" },
  { icon: Wifi, text: "Não cai: o atendimento não depende do celular ligado nem de reconectar" },
];

/**
 * Aba WhatsApp das lojas que usam SÓ a conexão oficial (flag somente_oficial
 * do /api/whatsapp/status): um cartão só, sem QR/Baileys.
 */
export default function ConexaoOficial({ status }) {
  const conectado = !!status?.oficial_conectado;
  const numero = status?.oficial_numero || "";
  const nome = status?.oficial_nome || "";

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <div className="bg-card rounded-2xl border-2 border-green-500/60 shadow-sm p-6 sm:p-8">
        <div className="flex items-start gap-4">
          <div className="p-3 rounded-xl bg-green-100 dark:bg-green-900/30 shrink-0">
            <CheckCircle className="w-7 h-7 text-green-600" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <h2 className="text-xl font-semibold">WhatsApp Oficial (Meta)</h2>
              <span
                className={`text-[11px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full ${
                  conectado
                    ? "bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300"
                    : "bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300"
                }`}
              >
                {conectado ? "Conectado" : "Não conectado"}
              </span>
            </div>
            <p className="text-sm text-muted-foreground mt-1">
              O atendimento da CLEO passa pela API oficial do WhatsApp.
            </p>
          </div>
        </div>

        {conectado && numero && (
          <div className="mt-6 rounded-xl border bg-muted/40 px-4 py-3">
            <p className="text-xs text-muted-foreground">Número conectado</p>
            <p className="text-lg font-semibold tracking-wide">{numero}</p>
            {nome && <p className="text-sm text-muted-foreground">{nome}</p>}
          </div>
        )}

        <ul className="mt-6 space-y-3">
          {VANTAGENS.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-start gap-3 text-sm">
              <Icon className="w-4 h-4 text-green-600 mt-0.5 shrink-0" />
              <span>{text}</span>
            </li>
          ))}
        </ul>

        <Button
          className={`mt-6 w-full ${
            conectado ? "" : "bg-green-600 hover:bg-green-700 text-white"
          }`}
          variant={conectado ? "outline" : "default"}
          onClick={abrirConexaoOficial}
        >
          {conectado ? "Conectar outro número" : "Conectar WhatsApp Oficial"}
        </Button>
      </div>
    </div>
  );
}
